/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InconsistenciesExportRequest } from '../../models/inconsistencies-export-request';

export interface PostFeV1LacEventsInconsistenciesResolvedExport$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
      body?: InconsistenciesExportRequest
}

export function postFeV1LacEventsInconsistenciesResolvedExport$Json(http: HttpClient, rootUrl: string, params?: PostFeV1LacEventsInconsistenciesResolvedExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, postFeV1LacEventsInconsistenciesResolvedExport$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

postFeV1LacEventsInconsistenciesResolvedExport$Json.PATH = '/v1/lac-events/inconsistencies/resolved/export';
